import { IconButton, TextField } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useState } from "react";

type ChatMessage = { id?: number, shownAtSeconds: number, username: string, content: string };

interface ChatMessageCardProps {
  message: ChatMessage;
  onMessageChange: (message: {
    id?: number;
    shownAtSeconds: number;
    username: string;
    content: string;
  }) => void;
  onMessageDelete: () => void;
}

export const ChatMessageCard: React.FC<ChatMessageCardProps> = ({ message, onMessageChange, onMessageDelete }) => {
  const [localMessage, setLocalMessage] = useState<ChatMessage>(message);

  function handleMessageChange(event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    const field = event.target.name;
    setLocalMessage({ ...localMessage, [field]: event.target.value });
    onMessageChange({ ...localMessage, [field]: event.target.value });
  }

  function handleMessageDelete() {
    onMessageDelete();
  }

  return <div style={{ display: "flex", justifyContent: "space-between", gap: "1rem", padding: "1rem", backgroundColor: "#00b9db", borderRadius: "4px", marginBottom: "1rem" }}>
    <div style={{ display: "flex", gap: "1rem", flex: 1 }}>
      <TextField
        type="number"
        label="Shown At (seconds)"
        name="shownAtSeconds"
        value={localMessage.shownAtSeconds}
        onChange={handleMessageChange}
      />
      <TextField
        label="Username"
        name="username"
        value={localMessage.username}
        onChange={handleMessageChange}
      />
      <TextField
        label="Content"
        name="content"
        value={localMessage.content}
        fullWidth
        multiline
        minRows={3}
        maxRows={10}
        onChange={handleMessageChange}
      />
    </div>
    <div>
      <IconButton
        color="error"
        onClick={handleMessageDelete}
      >
        <DeleteIcon />
      </IconButton>
    </div>
  </div>;
};
